import React from 'react';

const PROBLEMS = [
  {
    emoji: '📱',
    title: 'Too Many Apps',
    body: "You open one app. Then another. Then another. Then another. It's a lengthy, repetitive process every single time.",
  },
  {
    emoji: '💸',
    title: 'Missed Opportunities',
    body: "You sell to one buyer for £2. Another would've paid £5. You'll never know.",
  },
  {
    emoji: '❓',
    title: 'Unpredictable Buyers',
    body: "Different buyers pay best for different items. You can't predict it without checking all of them.",
  },
];

export default function ProblemSection() {
  return (
    <section className="py-24 md:py-32 px-4 sm:px-6 lg:px-8 bg-[#0A0A0A]" data-testid="problem-section">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-white mb-12 tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Stop Leaving Money on the Table
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {PROBLEMS.map((p) => (
            <div key={p.title} className="bg-[#0A0A0A] border border-zinc-800/50 rounded-2xl p-8 hover:border-[#00D26A]/40 transition-colors shadow-sm">
              <div className="text-4xl mb-4">{p.emoji}</div>
              <h3 className="text-xl font-semibold text-white mb-3">{p.title}</h3>
              <p className="text-zinc-400 leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
